/** @module csi/action/NewRefNodeMixin */
define([
	"dojo/_base/array",
	"dojo/_base/declare",
], function(array,declare) {

	function _validateRefNode(view, refNode) {
		if (refNode && !refNode.parentNode) {
			refNode = view.getRefNodeById(view.getRefNodeId(refNode));
		}

		return refNode;
	}

	return declare(null, {
		// Boolean: indicates that action works on view refNode
		bRefNode: true,

		// Boolean: indicates whether to invoke edit heading
		// bEditHeading: false,

		/** @property {string} _newUrlNext - node url following new node(s) */
		_newUrlNext: null,

		/** @property {string} _newUrlPrevious - node url preceding new node(s) */
		_newUrlPrevious: null,

		/** @property {string} _newTypeSortAttribute - id of sort attribute when inserting into a data store that is sorted by an attribute on node (rather than in refvector) */
		_newTypeSortAttribute: null,

		/** @property {string[]} _newResultUrls - list of urls in data store */
		_newResultUrls: null,

		constructor: function() {
			// listen for following function calls to add behavior related to stored sort order attributes
			this._connectEvent(this, "onStart", this._newStart);
			this._connectEvent(this, "onValidate", this._newValidate);
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			var node = this.getNode();
			return node ? [node] : [];
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add dependency paths for view to request to get new nodes - no need to do so
			// if navigating to the new node rather than updating existing view with new node
			var	req = this.inherited(arguments);
			if (req && !this.bNavigate) {
				req.addDependencyPaths(this.widget.getRefNodePaths(this.refNode));
			}

			return req;
		},

		_newPreProcess: function() {
			// summary: action not allowed if rows sorted for ordered relationships
			return true;
		},

		_newPostProcessRefNode: function(/*DOMNode*/refNode) {
			// summary: handle various cases where new node can be created
			var	view = this.widget;
			if (!view.isValidView()) {
				return;
			}

			if (view.allowsSelections()) {
				// select new node(s) if tracking selections
				var	fd = view.defView.m_formData;
				var	nodes = this.getNewNodes();

				if (fd.m_bSelectOne) {
					nodes = [nodes[0]];
				}

				array.forEach(nodes, function(node) {
					fd.changeSelection(view.getContext(node.$URL), true);
				});

				if (fd.m_bAllowAddNewFocus && this.bEditHeading) {
					// focuses on the newly created row with text box for editing
					this.setProgress(null);
					view.editHeading(refNode, true);
				}
			} else if (this.bEditHeading) {
				// select first heading in new block unless using dialog to create new item
				this.setProgress(null);
				view.editHeading(refNode, true);
			}
		},

		/**
		 * Track previous and next DOMNodes and urls when controller starts
		 */
		_newStart: function() {
			if (!this.refNode) {
				return;
			}

			var view = this.widget;
			var qr = view.getQueryResultByDomNode(this.refNode);
			if (qr) {
				// track information for sort order processing
				var qrNext = this.refNodeNext ? view.getQueryResultByDomNode(this.refNodeNext) : null;
				var qrPrev = this.refNodePrev ? view.getQueryResultByDomNode(this.refNodePrev) : null;

				var store = qr.parentResult?.store;
				this._newResultUrls = store && store.getResults();
				this._newTypeSortAttribute = qr.level.typeSortAttribute;
				this._newUrlNext = qrNext && qrNext.getResultUrl();
				this._newUrlPrevious = qrPrev && qrPrev.getResultUrl();
			}
		},

		/**
		 * Validate the refNode is still in the DOM - if the action is repeated, then the view may have been
		 * refreshed making the refNode invalid
		 */
		_newValidate: function() {
			const view = this.widget;
			this.refNode = _validateRefNode(view, this.refNode);
			this.refNodeNext = _validateRefNode(view, this.refNodeNext);
			this.refNodePrev = _validateRefNode(view, this.refNodePrev);
		}
	});
});